import { Component, OnInit } from '@angular/core';
import { ToastService } from 'src/app/core/toast.service';
import { ApiAtendenteService } from 'src/app/dao/api-atendente.service';
import { Atendente } from 'src/app/model/atendente';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FuncApiService } from 'src/app/dao/func-api.service';
import { GlobalService } from 'src/app/dao/global.service';

@Component({
  selector: 'app-atendente',
  templateUrl: './atendente.page.html',
  styleUrls: ['./atendente.page.scss'],
  providers: [MessageService, ConfirmationService]
})
export class AtendentePage implements OnInit {

  atendenteDialog: boolean;

  atendentes: Atendente[];

  atendente: Atendente;

  selectedatendentes: Atendente[];

  submitted: boolean;

  displayModal = false;

  atendenteSelecionado: Atendente;

  campoLink;

  linkwhatsapp;

  showdivLink = false;

  // tslint:disable-next-line: max-line-length
  constructor(private global: GlobalService, private funcApi: FuncApiService, private atendenteService: ApiAtendenteService, private toast: ToastService, private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.atendenteSelecionado = new Atendente();
    this.atendente = new Atendente();
    this.atendenteService.listarTodas().then(data => this.atendentes = data);
    this.atendente.tempo_uso_link = "3600";
  }

  openNew() {
    // tslint:disable-next-line: new-parens
    this.atendente = {};
    this.submitted = false;
    this.atendenteDialog = true;
  }

  deleteSelectedatendentes() {
    this.confirmationService.confirm({
      message: 'Deseja mesmo deletar os atendentes selecionados?',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.atendentes = this.atendentes.filter(val => !this.selectedatendentes.includes(val));
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.selectedatendentes.length; i++) {
          const result = this.atendenteService.excluir(this.selectedatendentes[i].id);
        }
        this.selectedatendentes = null;
        this.toast.showSucess('Atendentes Excluídos com Sucesso!');
      }
    });
  }

  editatendente(atendente: Atendente) {
    this.atendente = { ...atendente };
    this.atendenteDialog = true;
  }

  abrirModalLink(atendente: Atendente) {
    this.displayModal = true;
    this.atendenteSelecionado = atendente;
  }

  esconderModalLink(){
    this.atendente.tempo_uso_link = "3600";
    console.log("chamou");
    this.campoLink = '';
    this.linkwhatsapp = '';
    this.showdivLink = false;
    //document.getElementById('divLink').style.display = 'hidden';
  }

  async gerarLink(atendente: Atendente) {
    console.log(atendente);
    const result = await this.atendenteService.gerarLink(atendente.id, this.atendente.tempo_uso_link);
    console.log(result);
    const bodyCripto = { mensagem: result };
    const resultado = await this.funcApi.criptografar(bodyCripto);
    console.log(bodyCripto);
    console.log(resultado.mensagem);
    //document.getElementById('divLink').style.display = 'block';
    this.showdivLink = true;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.campoLink = `${this.global.dominio}/${this.global.loja}/local/index.php?link=${resultado.mensagem.toString()}`;
    this.setarLink(atendente, resultado.mensagem.toString());

    const celFormatado = atendente.telefone.replace(/[)(-]/g,'').split(' ').join('');

    if (isMobile) {
      this.linkwhatsapp = 'https://api.whatsapp.com/send?1=pt_BR&phone=55' + celFormatado + '&text=' + this.campoLink + '';
    } else {
      this.linkwhatsapp = 'https://web.whatsapp.com/send?phone=55' + celFormatado + '&text=' + this.campoLink + '';
    }
  }

  async setarLink(atendente: Atendente, link) {
    console.log(atendente);
    const result = await this.atendenteService.setarLink(atendente.id, link);
    console.log(result);
  }

  enviarWhatsapp(link) {
    window.open(link);
  }


  deleteatendente(atendente: Atendente) {
    this.confirmationService.confirm({
      message: 'Deseja mesmo deletar o Atendente ' + atendente.nome + '?',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const result = this.atendenteService.excluir(atendente.id);
        this.atendentes = this.atendentes.filter(val => val.id !== atendente.id);
        this.atendente = {};
        this.toast.showSucess('Atendente Excluído com Sucesso!');
      }
    });
  }

  hideDialog() {
    this.atendenteDialog = false;
    this.submitted = false;
  }

  async saveatendente() {
    this.submitted = true;

    if (this.atendente.nome.trim()) {
      if (this.atendente.id) {
        this.atendentes[this.findIndexById(this.atendente.id)] = this.atendente;
        this.atendente.nome = this.atendente.nome.replace(/\s/gi, '_');
        this.atendenteService.atualizar(this.atendente);
        this.toast.showSucess('Atendente Atualizado com Sucesso!');
      } else {
        // tslint:disable-next-line: radix
        this.atendente.nome = this.atendente.nome.replace(/\s/gi, '_');
        const result = await this.atendenteService.adicionar(this.atendente);
        this.atendentes.push(result);
        this.toast.showSucess('Atendente Cadastrado com Sucesso!');
      }

      this.atendentes = [...this.atendentes];
      this.atendenteDialog = false;
      this.atendente = {};
    }
  }

  findIndexById(id: number): number {
    let index = -1;
    for (let i = 0; i < this.atendentes.length; i++) {
      if (this.atendentes[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  }
}

